import { Icon } from '@oneaudi/unified-web-components';
import React from 'react';
import styled from 'styled-components';

interface InfoIconProps {
  size?: 's' | 'l' | 'xs';
  color?: string;
}

const IconDiv = styled.div<{ color?: string }>`
  svg {
    color: ${({ color }) => color ?? '#009900'};
  }
`;

const InfoIcon: React.FC<InfoIconProps> = ({ size = 's', color }) => (
  <IconDiv color={color}>
    <Icon name="info-circle" size={size} />
  </IconDiv>
);

export default InfoIcon;
